<template>
  <b-container class="my-5">
    <h3>Categories</h3>
    <div id="categories-wrapper" class="d-flex flex-nowrap">
      <b-link :to="{name: 'Category', params: {uuid: category.uuid, id: category.id}}"  :class="['category-container w-100 overflow-hidden position-relative d-inline-flex p-3', { 'mr-3': index < formattedCategories.length - 1 }]"
        v-for="(category, index) in formattedCategories" :key="`category_${index}`"
        :style="{
          'background-color': category.background_color
        }">
        <p class="align-self-end mb-0"> {{ category.name }} </p>
        <img src="@/assets/images/estore_categories_frame.svg" alt="pattern" class="img-fluid w-100 h-100 category-texture position-absolute">
      </b-link>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      homeWebLayout: "design/homeWebLayout"
    }),
    formattedCategories: {
      get() {
        return Object.keys(this.homeWebLayout).length > 0
          ? JSON.parse(this.homeWebLayout.categories)
          : [];
      },
      set(categories) {
        return categories;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@700&display=swap');
h3 {
  font-size: 30px;
  color: #2F3941;
  @extend .mainFontBold;
}
#categories-wrapper {
  .category-container {
    height: 125px;
    border-radius: 23px;
    background: red;
    &:hover {
      text-decoration: none;
    }
    p {
      font-size: 18px;
      color: #fff;
      z-index: 1;
      @extend .mainFontBold;
    }
    .category-texture {
      filter: opacity(0.05);
      top: 0;
      left: 0;
      object-fit: cover;
      z-index: 0;
    }
  }
}
@media (max-width: 767px) {
  #categories-wrapper {
    overflow-x: auto;
    .category-container {
      flex-shrink: 0;
      min-width: 150px;
      width: fit-content !important;
    }
  }
}
</style>
